export enum FileType {
  photo = 'F',
  attachment = 'B'
}
